import { Injectable } from '@angular/core';
import { HttpClient } from 'src/core/common/domain/http/http-client';
import { ApiService } from 'src/core/api/domain/api.service';
import { ExceptionManagerService } from 'src/core/common/domain/exceptions/exception-manager.service';
import { ApiAccessService } from '../../common/domain/api-access/api-access.service';
import { ConnectivityService } from '../../connection/domain/connectivity.service';
import { NoConnectionException } from '../../common/domain/exceptions/no-connection-exception';
import { AttendanceRepository } from '../domain/attendance.repository';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { AttendancePunchTooSoonException } from '../../common/domain/exceptions/attendance-punch-too-soon-exception';
import { LocalDate } from '../../common/domain/date/local-date';

@Injectable({
  providedIn: 'any',
})
export class HttpAttendanceRepository extends AttendanceRepository {
  constructor(
    private readonly apiAccessService: ApiAccessService,
    private readonly apiService: ApiService,
    private readonly client: HttpClient,
    private readonly connectivityService: ConnectivityService,
    private readonly exceptionManager: ExceptionManagerService
  ) {
    super();
  }

  async createPunch(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        if (!this.connectivityService.isOnline()) {
          reject(this.exceptionManager.manage(new NoConnectionException()));
          return;
        }

        await this.apiAccessService.renewApiAccessIfNeeded();
        const payload = {
          punched_at: LocalDate.now().atom,
        };
        await this.client.post(`${this.apiService.baseUrl()}/attendance.punch`, payload, {}, true, true);
        resolve();
      } catch (exception) {
        // specific exceptions management
        if (exception instanceof HttpErrorResponse) {
          switch (exception.status) {
            case HttpStatusCode.TooManyRequests:
              return reject(AttendancePunchTooSoonException.fromError(exception));
          }
        }

        // general exceptions management
        reject(this.exceptionManager.manage(exception));
      }
    });
  }
}
